import { useState } from "react";
import FacilityAccordion from "@/components/feature/FacilityAccordion";

const facilities = [
  { name: "Mandeville Post Office — Main Branch", address: "3300 Highway 190, Mandeville, LA 70471", hours: "Mon–Fri, 9:00 AM – 5:00 PM", phone: "(985) 626-4531", type: "Post Office", note: "Passport acceptance clerk. Appointment strongly recommended. Bring completed DS-11 for first-time applicants.", featured: true },
  { name: "Covington Post Office", address: "417 N New Hampshire St, Covington, LA 70433", hours: "Mon–Fri, 9:00 AM – 5:00 PM", phone: "(985) 892-2001", type: "Post Office", note: "St. Tammany Parish seat option. Convenient for Covington and northern Mandeville residents.", featured: false },
  { name: "Madisonville Post Office", address: "416 Covington St, Madisonville, LA 70447", hours: "Mon–Fri, 9:00 AM – 4:30 PM", phone: "(985) 845-4731", type: "Post Office", note: "Lakefront community option for Madisonville and Abita Springs residents.", featured: false },
  { name: "Lacombe Post Office", address: "28115 N Hwy 190, Lacombe, LA 70445", hours: "Mon–Fri, 9:00 AM – 4:30 PM", phone: "(985) 882-6941", type: "Post Office", note: "East St. Tammany Parish option. Call ahead to confirm passport clerk availability.", featured: false },
];

export default function MandevilleAcceptanceFacilitiesSection() {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  return (
    <section id="facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Mandeville
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            First-time passport applicants must appear in person at an acceptance facility. Renewals can typically be handled entirely by mail — start your order online to confirm your eligibility.
          </p>
        </div>

        <div className="space-y-3 mb-8">
          {facilities.map((f, i) => (
            <FacilityAccordion
              key={i}
              facility={f}
              isExpanded={expandedIndex === i}
              onToggle={() => setExpandedIndex(expandedIndex === i ? null : i)}
            />
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg border border-gray-200 p-5 flex flex-col md:flex-row items-start md:items-center gap-4">
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
            <i className="ri-lightbulb-line text-[#1A365D] text-lg"></i>
          </div>
          <div className="flex-1">
            <p className="font-bold text-[#1A365D] text-sm mb-1">Already have a passport to renew?</p>
            <p className="text-gray-500 text-sm leading-relaxed">
              Renewals can often be handled entirely by mail — no facility visit required. Start your order online, and we will confirm your eligibility and send your personalized checklist. Most Mandeville clients never need to set foot in a post office.
            </p>
          </div>
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-1.5 bg-[#1A365D] hover:bg-[#0F2240] text-white font-bold text-xs px-5 py-2.5 rounded-md transition-all whitespace-nowrap flex-shrink-0">
            Start Renewal <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}